/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import React from 'react';
import {useErrorDisplay} from 'src/utils/useErrorDisplay';
import {DevErrorDisplay} from './DevErrorDisplay';

/**
 * Container component that displays errors from the useErrorDisplay hook.
 * Multiple errors are stacked vertically with spacing.
 */
export const ErrorDisplayContainer: React.FC = () => {
  const {errors, dismissError} = useErrorDisplay();

  if (errors.length === 0) {
    return null;
  }

  return (
    <>
      {errors.map((displayError, index) => (
        <div
          key={displayError.id}
          style={{
            position: 'fixed',
            top: 20 + index * 10, // Stagger multiple errors
            right: 20,
            zIndex: 10000 + index,
          }}
        >
          <DevErrorDisplay
            error={displayError.error}
            onDismiss={() => dismissError(displayError.id)}
          />
        </div>
      ))}
    </>
  );
};
